<!--
트래킹검수 > 검수화면 > 검수대상 리스트 > 요청사항 컴포넌트
 - 요청사항 확인(체크) 기능이 있음
------------------------------------
-->
<template>
    <div>
        <!-- 요청사항 있음 -->
        <div
            v-if="request"
            v-html="requestBr"
            :class="classObj"
            @click="checked = ! checked"
            title="click to confirm"
        >
        </div>

        <!-- 요청사항 없음 -->
        <div
            v-if="! request"
            class="uk-text-muted"
        >
            요청사항이 없습니다
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            // 요청사항
            request: {
                type: String,
                default: null,
            },
        },
        data: function () {
            return {
                // (bool) 확인여부
                checked: false,
            };
        },
        computed: {
            /**
             * css 클래스명 object
             */
            classObj: function () {
                return {
                    request: true,
                    checked: this.checked,
                };
            },

            /**
             * br 태그 적용
             * @returns {string}
             */
            requestBr: function () {
                if (this.request === null) {
                    return '';
                }
                return this.request.replace(/(?:\r\n|\r|\n)/g, '<br />');
            },
        },

        methods: {

        },
    }
</script>

<style lang="scss" scoped>
    .request {
        text-align: left;
        padding: 10px;
        
        background-color: #ffffdd;
        
        border: 1px solid #efefef;
        -webkit-box-shadow: 3px 3px 3px #c3cee0;
        -moz-box-shadow: 3px 3px 3px #c3cee0;
        box-shadow: 3px 3px 3px #c3cee0;
        
        margin-bottom: 10px;
        color: #000;
        font-size: 1.5rem;

        cursor: pointer;

        &.checked {
            text-decoration-line: line-through;

            background-color: #fefefe;
            color: #999;
        }
    }
</style>